import React from "react";
import classnames from "classnames";
import "./Switch.scss";

const Switch = React.forwardRef(
  ({ checked, onChange, label, size, theme }, ref) => (
    <div
      className={classnames("switch-container", {
        "switch-container__dark": theme == "dark"
      })}
    >
      <label className={classnames("switch", size)}>
        <input
          type="checkbox"
          onChange={onChange}
          checked={checked}
          ref={ref}
        />
        <span className="slider round" />
      </label>
      {label && <span className="switch__label">{label}</span>}
    </div>
  )
);

export default Switch;
